import React from "react";
import HeroVideo1 from "../components/HeroVideo1";
import ImageText2 from "../components/Imagetext2";

import video from "../assets/videos/startstop.mp4";
import imageurl1 from "../assets/images/startstop.png";
import video2 from "../assets/videos/service2.mp4";
function StartStop() {
  const text1 = (
    <>
      <p className="text-white text-lg">
        De Start Stop functie zorgt ervoor dat de auto automatisch afslaat als
        uw voertuig tot stilstand komt en automatisch weer start op het moment
        dat u weer gaat rijden. Dit zorgt ervoor dat de uitstoot van schadelijke
        stoffen vermindert en dat u brandstof bespaart. Vooralsnog vinden velen
        dit niet prettig rijden en willen ze deze functie deactiveren.
      </p>
      <br />
      <p className="text-white text-lg">
        Bij X-TREMETUNINGS bieden wij de service om de Start Stop functie
        volledig te deactiveren als u het onprettig vindt dat uw auto
        automatisch afslaat en start.
      </p>
    </>
  );
  return (
    <div>
      <HeroVideo1 videoSource={video} heading="START STOP" />
      <ImageText2
        text={text1}
        imageUrl={imageurl1}
        leftColor="#000"
        rightColor="#000"
        textColor="white"
        borderColor="#BD0E0E"
        borderWidth="2px"
      />
      <HeroVideo1
        videoSource={video2}
        heading="Benieuwd welke services er beschikbaar zijn voor uw auto?Kies uw auto voor de beschikbare services of klik hier om contact met ons op te nemen!"
        buttontext="Zoek uw optimalisatie"
        buttonlink="/contact-us"
      />
    </div>
  );
}

export default StartStop;
